const appUrl = process.env.REACT_APP_BASE_APP_URL;

export function redirectToApp(tenantId: string, sut: string) {
  const fromURL = sessionStorage.getItem('msp_loggedoutfrom');
  const redirectUrl = `//${tenantId}.${appUrl}/auth/${sut}${fromURL ? '?forward=' + fromURL : ''}`;
  sessionStorage.removeItem('msp_loggedoutfrom');
  window.location.href = redirectUrl;
}